import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class ForDeveloperGuard implements CanActivate, CanLoad {
	/**
	 * Constructor to initialize services
	 *
	 * @param router
	 * @param logger
	 * @param configService
	 */
	constructor(private router: Router, private logger: LoggerService, private configService: ConfigService) {}

	/**
	 * CanActivate handler for routing
	 *
	 * @returns
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.guardHandling(route.data['guardRedirectUrl']);
	}

	/**
	 * CanLoad handler for child routing
	 *
	 * @returns
	 */
	canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
		return this.guardHandling(route.data['guardRedirectUrl']);
	}

	/**
	 * Guard handling
	 *
	 * @param redirectUrl
	 * @returns
	 */
	private guardHandling(redirectUrl?: string): Observable<boolean> | Promise<boolean> | boolean {
		if (this.configService.config.production) {
			const url = !!redirectUrl ? redirectUrl : '/';
			this.router.navigate([url]).catch((err) => {
				this.logger.error(err);
			});
		}
		return !this.configService.config.production;
	}
}
